import * as React from 'react'

import { DataBox } from '@/app/features/common/DataBox'
import { DriversIcon } from '@/app/features/icons/Drivers'
import { TruckIcon } from '@/app/features/icons/Truck'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { Loader } from '@/ui'
import { DashboardData } from '../types'

type Props = {
  stats?: DashboardData['payroll'] | null
  activeDrivers?: number
  activeVehicles?: number
  isLoading?: boolean
  isRefreshing?: boolean
}
export const PersonnelAndFinanceCard = ({
  stats,
  activeDrivers,
  activeVehicles,
  isLoading,
  isRefreshing,
}: Props) => {
  const { t } = useLocalize()
  return (
    <div className="tw-relative tw-flex tw-flex-col tw-border-b tw-border-r tw-border-base-300 tw-bg-primary-linear tw-p-4 lg:tw-w-1/3 lg:tw-border-b-0">
      {isRefreshing && (
        <Loader
          position="absolute"
          className="tw-inset-0 tw-z-10 tw-bg-base-100/60 tw-backdrop-blur-[1px]"
          size="sm"
        />
      )}
      <div className="tw-flex tw-flex-wrap tw-border-b tw-border-base-300">
        <DataBox
          className="tw-flex-1 tw-py-8 tw-pl-4 tw-pr-3"
          icon={<DriversIcon className="tw-h-8 tw-w-8" />}
          data={activeDrivers || 0}
          description={t('dashboard.active-drivers')}
          isLoading={isLoading}
        />
        <DataBox
          className="tw-flex-1 tw-px-3 tw-py-8"
          icon={<TruckIcon className="tw-h-8 tw-w-8" />}
          data={activeVehicles || 0}
          description={t('dashboard.active-vehicles')}
          isLoading={isLoading}
        />
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-justify-start tw-gap-8 tw-pt-8">
        <DataBox
          data={`${(stats?.totalGross || 0).toLocaleString('pl-PL')} PLN`}
          description={t('dashboard.total-gross-salary')}
          percentage={stats?.totalGrossChangePct || undefined}
          isLoading={isLoading}
        />
        <DataBox
          data={`${(stats?.bonusesGross || 0).toLocaleString('pl-PL')} PLN`}
          description={t('dashboard.bonuses-gross')}
          isLoading={isLoading}
        />
        <DataBox
          data={`${(stats?.delegationsGross || 0).toLocaleString('pl-PL')} ${'PLN'}`}
          description={t('dashboard.delegations-gross')}
          percentage={stats?.delegationsChangePct || undefined}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
